import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: 130,
  },
  versionButton: {
    marginLeft: "auto",
    boxSizing: "border-box",
    border: "2px solid #4A4E69",
    color: "rgb(255, 255, 255)",
    backgroundColor: "#4A4E69",
    fontFamily: "Gilroy-SemiBold, helvetica, arial, sans-serif",
    fontSize: "1.05rem",
    lineHeight: 1,
    padding: "1rem",
    pointerEvents: "auto",
    opacity: 1,
    textDecoration: "none",
    position: "fixed",
    right: "0px",
    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    zIndex: 100,
    width: "150px",
    marginTop: "-20px",
    borderRadius: "4px 0 0 4px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "rgb(148, 123, 243)",
      border: "2px solid transparent",
      color: "rgb(255, 255, 255)",
      transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      width: "170px",
      transform: "translateX(-5px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    },
  },
  changelog: {
    width: 0,
    position: "fixed",
    right: 0,
    top: "91px",
    backgroundColor: "#ffffff",
    height: "calc(100% - 134px)",
    zIndex: 200,
    overflow: "hidden",
    transition: "width 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    padding: 0,
    border: "none",
    borderLeft: "1px solid #e0e0e0",
    boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.15), -2px 0 6px rgba(0, 0, 0, 0.1)",
    color: "#3b4151",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#c1c1c1",
      borderRadius: "3px",
      "&:hover": {
        backgroundColor: "#a8a8a8",
      },
    },
  },
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    border: "1px solid #e0e0e0",
    color: "#666",
    width: "36px",
    height: "36px",
    zIndex: 210,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f44336",
      color: "white",
      borderColor: "#f44336",
      transform: "scale(1.1)",
    },
  },
  modalBackdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 199,
    opacity: 0,
    visibility: "hidden",
    transition: "opacity 0.3s ease, visibility 0.3s ease",
    "&.visible": {
      opacity: 1,
      visibility: "visible",
    },
  },
  changelogHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e0e0e0",
    padding: "16px 0",
    marginBottom: "20px",
    zIndex: 205,
  },
  changelogTitle: {
    fontSize: "1.3rem",
    fontWeight: "bold",
  },
}));
